import useAnalysis from "@app/pages/samples/utils/useAnalysis";
import React from "react";
import { Typography } from "@mui/material";

const PreparationBPP = () => {

    const { currentPreparation } = useAnalysis();
  
    return (
        <>
          {currentPreparation.index !== undefined && (
            <Typography variant="body1" color="error">
              Para el análisis Beta PP no se realiza Preparación, sólo pulsar el botón ‘Guardar’ para continuar.
            </Typography>
          )}
        </>
      );
};

export default PreparationBPP;